import { msg } from "@lit/localize";
import { createAsyncAction, createAsyncActionGroup } from "@progressive-development/pd-spa-helper";
import type { ris } from "@progressive-development/politik-model";

import type { DrucksachenListe } from "../service/artefakt-service.js";
import type {
  DrucksacheMitWeg,
  EntscheidungenStammdaten,
} from "../service/entscheidungen-service.js";

/**
 * Async-Actions von Block 2 — je Ansicht eine, plus die Stammdaten.
 *
 * Der Zuschnitt folgt den Aufrufen, nicht der Bequemlichkeit: Die Liste holt
 * IHR Artefakt (einmal je Sitzung), die Detailseite IHRE Drucksache, die
 * Sitzung IHRE Sitzung. Alle sind als Hintergrund-Ladevorgänge registriert —
 * die Seiten bauen sich auf, sie warten nicht hinter einem Modal.
 */

/**
 * Das Listen-Artefakt — alle Drucksachen, einmal je Sitzung (`fireOnce`).
 *
 * Kein Filter als Nutzlast: Gefiltert, gezählt und sortiert wird im Browser
 * (`entscheidungen-liste.ts`). Ein Filterwechsel ist damit kein Ladevorgang.
 */
export const loadDrucksachenListe = createAsyncAction<DrucksachenListe>("LOAD_DRUCKSACHEN_LISTE", {
  loadingTxt: msg("Drucksachen werden geladen…", { id: "app.entsch.loading.toast" }),
  smallBackground: true,
});

/** Payload: der sprechende Slug aus der URL. */
export const loadDrucksache = createAsyncActionGroup<string, DrucksacheMitWeg>("LOAD_DRUCKSACHE", {
  loadingTxt: msg("Drucksache wird geladen…", { id: "app.entsch.detail.loading.toast" }),
  smallBackground: true,
});

/** Payload: die Sitzungs-Id aus der URL. */
export const loadSitzung = createAsyncActionGroup<
  string,
  { sitzung: ris.Meeting; stationen: ris.Beratung[] }
>("LOAD_SITZUNG", {
  loadingTxt: msg("Sitzung wird geladen…", { id: "app.sitzung.loading.toast" }),
  smallBackground: true,
});

/** Gremien und Parteien — einmal je Sitzung im Browser. */
export const loadEntscheidungenStammdaten = createAsyncAction<EntscheidungenStammdaten>(
  "LOAD_ENTSCHEIDUNGEN_STAMMDATEN",
  {
    loadingTxt: msg("Stammdaten werden geladen…", { id: "app.entsch.stammdaten.loading.toast" }),
    smallBackground: true,
  },
);
